import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import FonteForm from "../../../components/forms/FonteForm.vue";
import { FonteService } from "../../../services/FonteService";

export default {
  name: "CriarFonte",
  components: {
    Breadcrumb,
    FonteForm
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "Início",
          disabled: false,
          href: "/"
        },
        {
          text: "Fontes",
          disabled: false,
          href: "/gerenciar-fontes"
        },
        {
          text: "Criar Fonte",
          disabled: true,
          href: "/fontes/criar"
        }
      ]
    };
  },
  methods: {
    async handleSave(formData) {
      try {
        // Criar FormData seguindo o padrão existente
        const postData = new FormData();
        
        postData.append("exercicio", formData.exercicio);
        postData.append("codigo_fonte", formData.codigoFonte);
        postData.append("descricao", formData.descricao);
        postData.append("ativo", formData.ativo ? 1 : 0);
        
        const response = await FonteService.store(postData);
        
        if (response) {
          // Redirecionar para a lista de fontes após salvar
          this.$router.push('/gerenciar-fontes');
        } else {
          throw new Error('Erro ao criar fonte');
        }
      } catch (error) {
        console.error('Erro ao criar fonte:', error);
        // O componente FonteForm já trata a exibição de mensagens de erro
        throw error;
      }
    },

    handleCancel() {
      // Retornar para a tela principal do menu
      this.$router.push('/gerenciar-fontes');
    }
  }
};
